import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Homeinteriors from '../../components/homeinteriors/homeinteriors';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Logo.png'
import WhatsAppCTA from '../../components/whatsapp/whatappcta';
import ProjectSection3 from '../../components/ProjectSection3/ProjectSection3';


const HomeInteriorsPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'Home Interiors'} />
            <Homeinteriors />

            <CtaSection />
            <ProjectSection3 />
            <Footer />
            <WhatsAppCTA />
            <Scrollbar />

        </Fragment>
    )
};

export default HomeInteriorsPage;